import { UUID } from 'crypto';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCreateOrUpdateTicketMutation, useGetTicketListeMutation } from '../../api/TicketAPI';
import { RootState } from '../../Store';
import { ITicket } from '../../types/Types';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import TicketCard from './component/TicketCard';
import styles from './ticketMain.module.scss';
import { formatToEuroDateTime } from '../../util/DateUtils';
import MaxInputAnzahlComponent from '../../component/MaxInputAnzahlComponent';

/**
 * @author noone
 */
export default function TicketMain() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    const [getTickets] = useGetTicketListeMutation();
    const [updateTicketAPI] = useCreateOrUpdateTicketMutation();
    const [statusZumAnzeigen, setStatusZumAnzeigen] = useState<string>("OFFEN");

    const [liste, setListe] = useState<ITicket[]>([]);
    const [gefilterteListe, setGefilterteListe] = useState<ITicket[]>([]);
    const [detailTicket, setDetailTicket] = useState<ITicket | null>(null);
    const [kurzbeschreibung, setKurzbeschreibung] = useState<string>("");
    const [langbeschreibung, setLangbeschreibung] = useState<string>("");

    function refresh() {
        getTickets().unwrap()
            .then(data => setListe(data))
            .catch((error) => console.log("ERROR: " + error));
    }

    function handleTicketStatusChanged() {
        setGefilterteListe([]);
        refresh();
    }

    const filterListe = () => {
        const gefilterteTickets = liste.filter(ticket => ticket.status === statusZumAnzeigen);
        setGefilterteListe(gefilterteTickets);
    }

    useEffect(() => {
        filterListe();
    }, [liste]);

    useEffect(() => {
        setDetailTicket(null);
        filterListe();
    }, [statusZumAnzeigen]);

    useEffect(() => {
        refresh();
    }, []);

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        updateTicketAPI({
            uid: "",
            kurzbeschreibung: kurzbeschreibung,
            langbeschreibung: langbeschreibung,
            reporter: (auth.user) ? auth.user?.email : "unbekannt",
            status: "OFFEN",
            prio: "MITTEL",
        })
            .then(() => { refresh(); })
            .then(() => {
                setKurzbeschreibung("");
                setLangbeschreibung("");
            })
            .catch((error: unknown) => alert("" + error));
    }

    const getAnzahlTickets = (status: string) => {
        return liste.filter(ticket => ticket.status === status).length
    }

    return (
        <>
            <LandingpageHeader />

            <div className="container">

                <button
                    onClick={() => {
                        navigate({
                            pathname: "/",
                            search: ""
                        });
                    }}

                    style={{ marginBottom: "20px" }}
                    className=' btn btn-outline-primary'
                >
                    <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                </button>

                <h3>Tickets</h3>

                <div style={{ marginTop: "30px" }}>
                    <h4>Neues Ticket erstellen</h4>
                    <form onSubmit={submit} className='form-horizontal'>
                        <div className="form-group">
                            <label htmlFor="kurzbeschreibung">Titel:</label>
                            <input maxLength={255} type="text" className="form-control" required={true} id="kurzbeschreibung" value={kurzbeschreibung} onChange={(e) => setKurzbeschreibung(e.target.value)} />
                            <MaxInputAnzahlComponent aktuell={kurzbeschreibung.length} max={255} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="langbeschreibung">Beschreibung:</label>
                            <textarea className="form-control"
                                id="langbeschreibung"
                                value={langbeschreibung}
                                rows={8}
                                maxLength={2048}
                                required={true}
                                onChange={(e) => setLangbeschreibung(e.target.value)} >
                            </textarea>
                            <MaxInputAnzahlComponent aktuell={langbeschreibung.length} max={2048} />
                        </div>
                        <input type='submit' value='Speichern' className="btn btn-primary" />
                    </form>
                </div>

                <div className={styles.statusCardContainer} >

                    <div className={styles.statusCard + " card"} style={{ backgroundColor: "orange", color: "white" }} onClick={() => setStatusZumAnzeigen("OFFEN")}>
                        <span className={styles.cardSpan}>
                            Offen ({getAnzahlTickets("OFFEN")})
                        </span>
                    </div>

                    <div className={styles.statusCard + " card"} style={{ backgroundColor: "#17a2b8", color: "white" }} onClick={() => setStatusZumAnzeigen("IN_ABSTIMMUNG")}>
                        <span className={styles.cardSpan}>
                            In Abstimmung ({getAnzahlTickets("IN_ABSTIMMUNG")})
                        </span>
                    </div>

                    <div className={styles.statusCard + " card"} style={{ backgroundColor: "blue", color: "white" }} onClick={() => setStatusZumAnzeigen("IN_BEARBEITUNG")}>
                        <span className={styles.cardSpan}>
                            In Bearbeitung ({getAnzahlTickets("IN_BEARBEITUNG")})
                        </span>
                    </div>

                    <div className={styles.statusCard + " card"} style={{ backgroundColor: "#e2e6ea", color: "black" }} onClick={() => setStatusZumAnzeigen("IN_ABNAHME")}>
                        <span className={styles.cardSpan}>
                            In Abnahme ({getAnzahlTickets("IN_ABNAHME")})
                        </span>
                    </div>

                    <div className={styles.statusCard + " card"} style={{ backgroundColor: "green", color: "white" }} onClick={() => setStatusZumAnzeigen("FERTIG")}>
                        <span className={styles.cardSpan}>
                            Fertig ({getAnzahlTickets("FERTIG")})
                        </span>
                    </div>

                    <div className={styles.statusCard + " card"} style={{ backgroundColor: "#c82333", color: "white" }} onClick={() => setStatusZumAnzeigen("WONTFIX")}>
                        <span className={styles.cardSpan}>
                            WontFix ({getAnzahlTickets("WONTFIX")})
                        </span>
                    </div>

                </div>

                <div className={styles.ticketCardContainer} >

                    <div>
                        Anzahl : {gefilterteListe?.length}

                        {gefilterteListe?.sort((item1: ITicket, item2: ITicket) => {
                            return new Date(item1.erstelltAm).getTime() - new Date(item2.erstelltAm).getTime();
                        })
                            .map(item => (

                                <div className="card" onClick={() => setDetailTicket(item)}
                                    style={{ cursor: "pointer", border: "1px solid #ccc", marginBottom: "10px", borderRadius: "5px", backgroundColor: detailTicket?.uid === item.uid ? "#f0f0f0" : "#fff" }}
                                >
                                    <div className="card-body">
                                        TICKET {item.nummer} : <span style={{ fontWeight: "bold" }}>{item.kurzbeschreibung}</span>
                                    </div>
                                    <div className="card-footer">
                                        <span style={{ margin: "0 10px" }}>Prio: {item.prio}</span>Erstellt am: {formatToEuroDateTime(item.erstelltAm)}
                                    </div>
                                </div>

                            ))}
                    </div>

                    <div>
                        {detailTicket !== null && <TicketCard
                            uid={detailTicket.uid}
                            refresh={handleTicketStatusChanged}
                            close={() => setDetailTicket(null)}
                        />}
                    </div>
                </div>
                <Footer />
            </div >
        </>
    );

}

export type ISache = {
    uid?: UUID,
    name: string,
    createDate: string,
}